import * as React from "react";
import { Route } from "react-router-dom";
import SchoolSettings from "../views/SchoolSettings";

export const CustomRoutes = [
    <Route key="school_settings" path="/school_settings" component={SchoolSettings} />,
];
